import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Stack, Box, Typography, Collapse } from "@mui/material";
import moment from "moment";
import "./sidebar.scss";

// Import icons
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Logo from "../../styles/img/CompliNYC-Logo.png";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { isAdmin } from "../../utils/helpers";
import ReportIcon from '../../styles/svg/report-navigation.svg';

///svg
import Schedule from '../../styles/svg/schedule.svg';
import Terms from '../../styles/svg/terms.svg';
import Inspector from '../../styles/svg/inspector.svg';
import Service from '../../styles/svg/service.svg';
import Client from '../../styles/svg/clients.svg';
import Building from '../../styles/svg/all-buildings.svg';
import AnnualCompliance from '../../styles/svg/annual-compliance.svg';
import HpdAffidavits from '../../styles/svg/hpd-affedavits.svg';
import Messaging from '../../styles/svg/messaging.svg';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import Parapet from '../../styles/svg/parapet.svg';
import Backflow from '../../styles/svg/backflow-report.svg';

export default function Sidebar() {
  const redirect = useNavigate();
  const [hpdOpen, setHpdOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const isRentalToken = localStorage.getItem("rental_access_token");

  const toggleHpd = () => {
    setHpdOpen(!hpdOpen);
  };

  return (
    <Box className="sidebar">
      <Box className="sidebar-logo">
        <img
          src={Logo}
          alt="CompliNYC"
          className="cursor-pointer"
          onClick={() => redirect("/")}
        />
      </Box>

      {isAdmin() ? (
        <Box className="sidebar-menu">
          <NavLink to="/home" className="sidebar-item">
            <HomeOutlinedIcon />
            <span>Home</span>
          </NavLink>

          <NavLink
            to={`/ticket?date=${JSON.stringify({
              key: "selection",
              startDate: moment(new Date()).format("YYYY-MM-DD"),
              endDate: moment(new Date()).format("YYYY-MM-DD"),
            })}`}
            className="sidebar-item"
          >
            <ConfirmationNumberOutlinedIcon />
            <span>Tickets</span>
          </NavLink>

          <NavLink to="/schedule-inspection" className="sidebar-item">
            <EventNoteOutlinedIcon />
            <span>Schedule Inspection</span>
          </NavLink>

          <NavLink to="/inspector" className="sidebar-item">
            <PersonOutlinedIcon />
            <span>Inspectors</span>
          </NavLink>

          <NavLink to="/service" className="sidebar-item">
            <SettingsOutlinedIcon />
            <span>Services</span>
          </NavLink>
          <NavLink to="/client" className="sidebar-item">
            <PeopleOutlinedIcon />
            <span>All Clients</span>
          </NavLink>

          <NavLink to="/buildings" className="sidebar-item">
            <BusinessOutlinedIcon />
            <span>All Buildings</span>
          </NavLink>

          <NavLink
            to={`/lead-compliance?year=${new Date().getFullYear()}`}
            className="sidebar-item"
          >
            <AssignmentOutlinedIcon />
            <span>Annual Compliance</span>
          </NavLink>

          <NavLink
            to={`/ll55?year=${new Date().getFullYear()}`}
            className="sidebar-item"
          >
            <GavelOutlinedIcon />
            <span>LL55</span>
          </NavLink>

          <NavLink
            to={`/fire-notice?year=${new Date().getFullYear()}`}
            className="sidebar-item"
          >
            <LocalFireDepartmentOutlinedIcon />
            <span>Fire Notices</span>
          </NavLink>

          <div className="sidebar-item dropdown-item" onClick={toggleHpd}>
            <ApartmentOutlinedIcon />
            <span>HPD</span>
            {hpdOpen ? (
              <ExpandLessIcon className="expand-icon" />
            ) : (
              <ExpandMoreIcon className="expand-icon" />
            )}
          </div>

          <Collapse in={hpdOpen} timeout="auto" unmountOnExit>
            <Box className="submenu">
              <NavLink
                to="/hpd/violations"
                className="sidebar-item submenu-item"
              >
                <ReportProblemOutlinedIcon />
                <span>HPD Violations</span>
              </NavLink>
              <NavLink to="/hpd/tickets" className="sidebar-item submenu-item">
                <GavelOutlinedIcon />
                <span>HPD Tickets</span>
              </NavLink>
              <NavLink
                to="/hpd/affidavits"
                className="sidebar-item submenu-item"
              >
                <AssignmentIndOutlinedIcon />
                <span>HPD Affidavits</span>
              </NavLink>
              <NavLink
                to="/hpd/pending-requests"
                className="sidebar-item submenu-item"
              >
                <PendingActionsOutlinedIcon />
                <span>Pending Requests</span>
              </NavLink>
            </Box>
          </Collapse>

          <NavLink to="/client-messaging" className="sidebar-item">
            <ChatOutlinedIcon />
            <span>Client Messaging</span>
          </NavLink>

          {/* <NavLink to="/parapet" className="sidebar-item">
            <img src={Parapet} alt="Coming soon" className="svg-icon"/>
            <span>Parapet</span>
          </NavLink>

          <NavLink to="/backflow-hpd-tickets" className="sidebar-item">
            <img src={Backflow} alt="Coming soon" className="svg-icon"/>
            <span>Backflow HPD Tickets</span>
          </NavLink> */}

          <NavLink to="/terms" className="sidebar-item">
            <DescriptionOutlinedIcon />
            <span>Terms</span>
          </NavLink>

          <NavLink to="/reports" className="sidebar-item">
            <img src={ReportIcon} alt="Report" className="svg-icon" />
            <span>Reports</span>
          </NavLink>

          <NavLink to="/document-upload" className="sidebar-item">
            <DescriptionOutlinedIcon />
            <span>Document Upload</span>
          </NavLink>
        </Box>
      ) : (
        <Box className="sidebar-menu">
          <NavLink to={`/client/${user?.role_id}`} className="sidebar-item">
            <HomeOutlinedIcon />
            <span>Home</span>
          </NavLink>

          <NavLink to="/schedule-inspection" className="sidebar-item">
            <EventNoteOutlinedIcon />
            <span>Schedule Inspection</span>
          </NavLink>

          <NavLink to="/buildings" className="sidebar-item">
            <BusinessOutlinedIcon />
            <span>All Buildings</span>
          </NavLink>

          <NavLink
            to={`/lead-compliance?year=${new Date().getFullYear()}`}
            className="sidebar-item"
          >
            <AssignmentOutlinedIcon />
            <span>Annual Compliance</span>
          </NavLink>

          <NavLink
            to={`/ll55?year=${new Date().getFullYear()}`}
            className="sidebar-item"
          >
            <GavelOutlinedIcon />
            <span>LL55</span>
          </NavLink>

          <div className="sidebar-item dropdown-item" onClick={toggleHpd}>
            <ApartmentOutlinedIcon />
            <span>HPD</span>
            {hpdOpen ? (
              <ExpandLessIcon className="expand-icon" />
            ) : (
              <ExpandMoreIcon className="expand-icon" />
            )}
          </div>

          <Collapse in={hpdOpen} timeout="auto" unmountOnExit>
            <Box className="submenu">
              <NavLink
                to="/hpd/violations"
                className="sidebar-item submenu-item"
              >
                <ReportProblemOutlinedIcon />
                <span>HPD Violations</span>
              </NavLink>

              <NavLink
                to="/hpd/affidavits"
                className="sidebar-item submenu-item"
              >
                <AssignmentIndOutlinedIcon />
                <span>HPD Affidavits</span>
              </NavLink>
            </Box>
          </Collapse>

           {isRentalToken && <NavLink
            onClick={() => {
              window.location.href = process.env.REACT_APP_FRONTEND_URL + '/rental';
            }}
            className="sidebar-item rental-nav"
          >
            <SupervisedUserCircleIcon />
            <span>Rental Service</span>
          </NavLink>}

          {/* <NavLink to="/parapet" className="sidebar-item">
            <img src={Parapet} alt="Coming soon" className="svg-icon"/>
            <span>Parapet</span>
          </NavLink>

          <NavLink to="/backflow-hpd-tickets" className="sidebar-item">
            <img src={Backflow} alt="Coming soon" className="svg-icon"/>
            <span>Backflow HPD Tickets</span>
          </NavLink> */}
        </Box>
      )}
    </Box>
  );
}
